import { useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';

import { useAuth } from '@restworld/feature-authentication';
import { useAccountsService } from '@restworld/data-services';

import { Header } from './components/header';
import { UserSettingsTabs } from './components/user-settings-tabs';
import { LayoutWrapper } from '../../../worker-app/layouts';
import UpdatePhoneNumberModal, {
  phoneNumberVerificationModalVisibleAtom,
  useShouldShowPhoneNumberVerificationModal,
} from '../common-phone-number-otp-validation-modal/update-phone-number-modal';
import OTPValidationModal from '../common-phone-number-otp-validation-modal/otp-validation-modal';
import { cn } from '@restworld/utils-common';

export function UserSettingsComponent() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { shouldShowPhoneNumberVerificationModal } = useShouldShowPhoneNumberVerificationModal();
  const accountServices = useAccountsService();
  const setPhoneNumberVerificationModalVisible = useSetAtom(phoneNumberVerificationModalVisibleAtom);

  useEffect(() => {
    if (shouldShowPhoneNumberVerificationModal) setPhoneNumberVerificationModalVisible(true);
  }, [setPhoneNumberVerificationModalVisible, shouldShowPhoneNumberVerificationModal]);

  return (
    <LayoutWrapper
      title={t('user-settings:page_title')}
      hasFooter
      hasNavbar
      showSearchBarInNavbar={user?.type !== 'employer'}
    >
      <UserSettingsWrapper>
        <Header />
        <div className="lg:mt-12 mt-8">
          <UserSettingsTabs />
        </div>
      </UserSettingsWrapper>
      <UpdatePhoneNumberModal
        headerTitle={t('common:verify_your_phone_number')}
        headerSubTitle={t('common:verify_phone_number_message')}
      />
      <OTPValidationModal onOTPVerificationSuccessFull={async () => await accountServices.me()} />
    </LayoutWrapper>
  );
}

const UserSettingsWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div className={cn('flex flex-col w-full', className)} {...props} />
);
